<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Usuários</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataUsers"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              @click="handleGoToNewUser"
              color="orangePcm"
              href="/controle-de-acesso/criar"
              target="_blank"
              v-if="permissaoTotal"
            >
              Criar Usuário
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="4" class="mr-2">
            <v-text-field
              v-model="search"
              clearable
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="Busca"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    color="bluePcm"
                    :disabled="item.perfil === 'operadores'"
                    :href="`/controle-de-acesso/atualizar/${item.id}`"
                    v-bind="attrs"
                    v-on="on"
                    @click="atualizarButton(item, $event)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom v-if="permissaoTotal">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="deletar(item)"
                    icon
                    small
                    dark
                    color="darkRed"
                    v-bind="attrs"
                    v-on="on"
                    v-if="item.id !== 1 && item.perfil !== 'operadores'"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Usuários: {{ qtdUsers }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ListPagination from "@/componentes/ListPagination";
import { registerVuexModule } from "@/utils/vuexUtils";
import { pagesHomeMixins } from "@/mixins/pagesHomeMixins";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";

import usersStore from "../_store";
import userHttpService from "../_services/userHttpService";

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: "Usuário",
        value: "name",
        align: "left",
      },
      {
        text: "Perfil",
        value: "perfil",
        align: "left",
      },
      {
        text: "E-mail",
        value: "email",
        align: "left",
        sortable: false,
      },
      {
        text: "Ações",
        value: "botoes",
        align: "center",
        sortable: false,
      },
    ],
    dataUsers: [],
    permissaoTotal: false,
    arrayPermissaoTotal: [
      process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_TOTAL,
      process.env.VUE_APP_ADMINISTRADOR,
    ],
  }),

  computed: {
    ...mapGetters("usuariosHomeModuleUsersStore", ["getAllUsers"]),

    numberOfPages() {
      return Math.ceil(this.dataUsers.length / this.itemsPerPage);
    },
    qtdUsers() {
      return this.dataUsers.length;
    },
  },

  async created() {
    registerVuexModule(this.$store, "usuariosHomeModuleUsersStore", usersStore);
    await this.listAllUsers();

    this.dataUsers = this.getAllUsers.map((user) => ({
      id: user.id,
      name: user.name,
      email: user.email,
      perfil: user.roles[0].name,
    }));

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    arrayPermissions.forEach((permissaoLocalStorage) => {
      if (this.arrayPermissaoTotal.includes(permissaoLocalStorage)) {
        this.permissaoTotal = true;
      }
    });

    this.showSkeleton = false;
  },

  methods: {
    ...mapActions("usuariosHomeModuleUsersStore", ["listAllUsers"]),
    ...obtainUserPermissions,

    handleGoToNewUser(event) {
      event.preventDefault();
      if (event.metaKey || event.ctrlKey) {
        const goToNewUser = this.$router.resolve({ name: "UserHome/criar" });
        window.open(goToNewUser.href, "_blank");
      } else {
        this.$router.push({ name: "UserHome/criar" });
      }
    },

    atualizar(event, item) {
      if (item.item.perfil !== "operadores" ) {
        if (event.metaKey || event.ctrlKey) {
          const updatePath = this.$router.resolve(`atualizar/${item.item.id}`);
          window.open(updatePath.href, "_blank");
        } else {
          this.$router.push(`atualizar/${item.item.id}`);
        }
      }
    },

    atualizarButton(item, event) {
      event.preventDefault();
      if (item.perfil !== "operadores" ) {
        if (event.metaKey || event.ctrlKey) {
          const updatePath = this.$router.resolve(`atualizar/${item.id}`);
          window.open(updatePath.href, "_blank");
        } else {
          this.$router.push(`atualizar/${item.id}`);
        }
      }
    },

    async deletar(item) {
      let resultado = window.confirm(
        `Deseja remover o usuário "${item.name}"?`
      );
      if (resultado) {
        try {
          await userHttpService.deleteUser(item.id);
          this.dataUsers = this.dataUsers.filter((x) => x.id !== item.id);
        } catch (error) {
          alert(error.response.data);
        }
      }
    },
  },
};
</script>
